// @ts-nocheck
import { type ReactNode } from 'react'
import { useSnapshot } from 'valtio'
import { ToastContainer } from 'react-toastify'
import { useUnauthenticatedPage } from '../../hooks/useUnauthenticatedPage'
import { proxyGlobalAuth } from '../../proxies/proxyGlobalAuth'
import { DetermineBrowserTabLogo } from '../../themes/logoFunctions'

interface LayoutProps {
  children: ReactNode
}
export function UnauthenticatedLayout ({ children }: LayoutProps): ReactElement {
  const shouldDisplay = useUnauthenticatedPage()
  const { siteTheme: { mainBodyColor } } = useSnapshot(proxyGlobalAuth)

  return (
    <>
      <DetermineBrowserTabLogo />
      <ToastContainer position="top-center" />
      <style jsx global>
        {`
            body {
              background: ${mainBodyColor};
            }
        `}
      </style>

      {shouldDisplay && children}
    </>
  )
}
